import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-block pt-2" }
const _hoisted_2 = { class: "form-label fw-bolder" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "d-block pt-2" }
const _hoisted_5 = { class: "form-label fw-bolder" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "form-label fw-bolder" }
const _hoisted_10 = { class: "col" }
const _hoisted_11 = { class: "form-label fw-bolder" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "d-block pt-2" }
const _hoisted_14 = { class: "form-label fw-bolder" }
const _hoisted_15 = {
  key: 0,
  class: "d-block pt-2"
}
const _hoisted_16 = { class: "form-label fw-bolder" }
const _hoisted_17 = ["value"]
const _hoisted_18 = {
  key: 1,
  class: "d-block pt-2"
}
const _hoisted_19 = { class: "form-label fw-bolder" }
const _hoisted_20 = { class: "table" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_22 = { class: "d-flex justify-content-end mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormInputClearable = _resolveComponent("FormInputClearable")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    show: true,
    title: _ctx.t('EditProduct'),
    "onUpdate:show": _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('update:show'))),
    closeOnOuterClick: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
      }, [
        _createElementVNode("label", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.t('Product')), 1),
          _createElementVNode("input", {
            type: "text",
            class: "form-control",
            value: _ctx.formData.productDisplayName,
            disabled: ""
          }, null, 8, _hoisted_3)
        ]),
        _createElementVNode("label", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.t('Description')), 1),
          _withDirectives(_createElementVNode("textarea", {
            class: "form-control",
            rows: "2",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.description) = $event)),
            disabled: !_ctx.isProductDescriptionEditable
          }, null, 8, _hoisted_6), [
            [_vModelText, _ctx.formData.description]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("label", null, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.t('Quantity')), 1),
              _createVNode(_component_FormInputClearable, {
                modelValue: _ctx.formData.quantityValue,
                validators: _ctx.validators.quantity,
                clearable: false,
                type: "number",
                "onUpdate:modelValue": _ctx.onQuantityUpdate
              }, null, 8, ["modelValue", "validators", "onUpdate:modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", null, [
              _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.t('UnitOfMeasure')), 1),
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: _ctx.formData.uom,
                disabled: ""
              }, null, 8, _hoisted_12)
            ])
          ])
        ]),
        _createElementVNode("label", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.t('CustomerClassification')), 1),
          _createVNode(_component_FormInputClearable, {
            modelValue: _ctx.formData.customerClassification,
            type: "text",
            "onUpdate:modelValue": _ctx.onClassificationUpdate
          }, null, 8, ["modelValue", "onUpdate:modelValue"])
        ]),
        (_ctx.formData.baseProductId)
          ? (_openBlock(), _createElementBlock("label", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.t('BaseProductId')), 1),
              _createElementVNode("input", {
                type: "text",
                class: "form-control",
                value: _ctx.formData.baseProductId,
                disabled: ""
              }, null, 8, _hoisted_17)
            ]))
          : _createCommentVNode("", true),
        (_ctx.formData.customFields && _ctx.formData.customFields.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("label", _hoisted_19, _toDisplayString(_ctx.t('CustomFields')), 1)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("table", _hoisted_20, [
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formData.customFields, (customField) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: customField.key
              }, [
                _createElementVNode("td", null, _toDisplayString(customField.key) + ":", 1),
                _createElementVNode("td", null, _toDisplayString(customField.value), 1)
              ]))
            }), 128))
          ])
        ]),
        _hoisted_21,
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_Btn, {
            onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.close()), ["prevent"])),
            class: "mx-2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Cancel', true)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_Btn, {
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.onSave()), ["prevent"])),
            disabled: !_ctx.isFormValid,
            primary: ""
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.t('Save', true)), 1)
            ]),
            _: 1
          }, 8, ["disabled"])
        ])
      ], 32)
    ]),
    _: 1
  }, 8, ["title"]))
}